export function timer(id: string, carbonDate: string, endCallbacks: ((id: string) => void)[] = []) {
    const element = document.getElementById(id);
    if (!element) {
        return;
    }

    const daysDiv = element.querySelector('.timer-days');
    const hoursDiv = element.querySelector('.timer-hours');
    const minutesDiv = element.querySelector('.timer-minutes');

    if (!daysDiv || !hoursDiv || !minutesDiv) {
        return;
    }

    const countdownDate = new Date(`${carbonDate}Z`).getTime();

    const updateCountdown = setInterval(() => {
        const now = new Date().getTime();
        const distance = countdownDate - now;

        // We are adding 1 min, so it won't display for entire minute as 00:00:00
        const countDownDistance = distance + 60000;

        const days = Math.floor(countDownDistance / 86400000);
        const hours = Math.floor((countDownDistance % 86400000) / 3600000);
        const minutes = Math.floor((countDownDistance % 3600000) / 60000);

        const daysTens = Math.floor(days / 10);
        const daysOnes = days % 10;

        const hoursTens = Math.floor(hours / 10);
        const hoursOnes = hours % 10;

        const isDistanceMoreThanOneMin = distance > 60000;
        const minutesTens = isDistanceMoreThanOneMin ? Math.floor(minutes / 10) : 0;
        const minutesOnes = isDistanceMoreThanOneMin ? minutes % 10 : 1;

        if (distance > 0) {
            daysDiv.innerHTML = `<span>${daysTens}</span><span>${daysOnes}</span>`;
            hoursDiv.innerHTML = `<span>${hoursTens}</span><span>${hoursOnes}</span>`;
            minutesDiv.innerHTML = `<span>${minutesTens}</span><span>${minutesOnes}</span>`;
        }
        if (distance < 0) {
            clearInterval(updateCountdown);
            endCallbacks.forEach((callback) => callback(id));
        }
    }, 1000);
}
